.instagramEmbed__iframe {
  background: #fff;
  border: 0;
  border-radius: 3px;
  box-shadow:
    0 0 1px 0 rgb(0 0 0 / 50%),
    0 1px 10px 0 rgb(0 0 0 / 15%);
  margin: 1px;
  max-width: 540px;
  min-width: 326px;
  padding: 0;
  width: 99.375%;
  width: calc(100% - 2px);
}

.instagramEmbed__link_A {
  background: #fff;
  line-height: 0;
  padding: 0;
  text-align: center;
  text-decoration: none;
  width: 100%;
}

.instagramEmbed__container {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.instagramEmbed__A {
  background-color: #f4f4f4;
  border-radius: 50%;
  flex-grow: 0;
  height: 40px;
  margin-right: 14px;
  width: 40px;
}

.instagramEmbed__B {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;

  &_1 {
    background-color: #f4f4f4;
    border-radius: 4px;
    flex-grow: 0;
    height: 14px;
    margin-bottom: 6px;
    width: 100px;
  }

  &_2 {
    background-color: #f4f4f4;
    border-radius: 4px;
    flex-grow: 0;
    height: 14px;
    width: 60px;
  }
}

.instagramEmbed__C {
  display: block;
  height: 50px;
  margin: 0 auto 12px;
  width: 50px;
}

.instagramEmbed__D {
  color: #3897f0;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 550;
  line-height: 18px;
}

.instagramEmbed__E {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 14px;

  &_1 {
    background-color: #f4f4f4;
    border-radius: 50%;
    height: 12.5px;
    transform: translateX(0) translateY(7px);
    width: 12.5px;
  }

  &_2 {
    background-color: #f4f4f4;
    flex-grow: 0;
    height: 12.5px;
    margin-left: 2px;
    margin-right: 14px;
    transform: rotate(-45deg) translateX(3px) translateY(1px);
    width: 12.5px;
  }

  &_3 {
    background-color: #f4f4f4;
    border-radius: 50%;
    height: 12.5px;
    transform: translateX(9px) translateY(-18px);
    width: 12.5px;
  }
}

.instagramEmbed__F {
  background-color: #f4f4f4;
  border-radius: 50%;
  flex-grow: 0;
  height: 20px;
  width: 20px;
}

.instagramEmbed__G {
  border-bottom: 2px solid transparent;
  border-left: 6px solid #f4f4f4;
  border-top: 2px solid transparent;
  height: 0;
  transform: translateX(16px) translateY(-4px) rotate(30deg);
  width: 0;
}

.instagramEmbed__H {
  border-right: 8px solid transparent;
  border-top: 8px solid #f4f4f4;
  transform: translateY(16px);
  width: 0;

  &_1 {
    background-color: #f4f4f4;
    flex-grow: 0;
    height: 12px;
    transform: translateY(-4px);
    width: 16px;
  }

  &_2 {
    border-left: 8px solid transparent;
    border-top: 8px solid #f4f4f4;
    height: 0;
    transform: translateY(-4px) translateX(8px);
    width: 0;
  }
}

.instagramEmbed__I {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  margin-bottom: 24px;

  &_1 {
    background-color: #f4f4f4;
    border-radius: 4px;
    flex-grow: 0;
    height: 14px;
    margin-bottom: 6px;
    width: 224px;
  }

  &_2 {
    background-color: #f4f4f4;
    border-radius: 4px;
    flex-grow: 0;
    height: 14px;
    width: 144px;
  }
}

.instagramEmbed__J {
  color: #c9c8cd;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 0;
  margin-top: 8px;
  overflow: hidden;
  padding: 8px 0 7px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.instagramEmbed__link_B {
  color: #c9c8cd;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  text-decoration: none;
}
